var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#0087D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1193 26.8365H9.45537V15.0374H13.1193V26.8365ZM11.2854 13.4279C10.1138 13.4279 9.16345 12.4574 9.16345 11.2858C9.16345 10.723 9.38701 10.1833 9.78495 9.78533C10.1829 9.38738 10.7226 9.16382 11.2854 9.16382C11.8481 9.16382 12.3878 9.38738 12.7858 9.78533C13.1837 10.1833 13.4073 10.723 13.4073 11.2858C13.4073 12.4574 12.4566 13.4279 11.2854 13.4279ZM26.8322 26.8365H23.1762V21.0928C23.1762 19.7239 23.1486 17.9684 21.2712 17.9684C19.3663 17.9684 19.0744 19.4557 19.0744 20.9942V26.8365H15.4144V15.0374H18.9284V16.6469H18.9797C19.4689 15.7198 20.6637 14.7415 22.4464 14.7415C26.1545 14.7415 26.8362 17.1834 26.8362 20.3551V26.8365H26.8322Z",
    fill: "#0087D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.54c5397ac8fd1ae4507e6708b8da21ce.svg";
export { ForwardRef as ReactComponent };